(function () {

  function placeAlerts() {
    document.querySelectorAll('.cultefc-stock-text').forEach(function(text) {
      var idx = parseInt(text.dataset.idx, 10);
      var allAlertLabels = document.querySelectorAll('.variant-option__button-label.has-stock-alert');
      var label = allAlertLabels[idx];
      if (!label) return;
      var fieldset = label.closest('fieldset');
      if (!fieldset) return;
      var fRect = fieldset.getBoundingClientRect();
      var lRect = label.getBoundingClientRect();
      text.style.left = (lRect.left - fRect.left + lRect.width / 2) + 'px';
      text.style.top = (lRect.height + 6) + 'px';
    });
  }

  function createAlerts() {
    document.querySelectorAll('.cultefc-stock-text').forEach(function(el) { el.remove(); });

    var allAlertLabels = document.querySelectorAll('.variant-option__button-label.has-stock-alert');
    if (!allAlertLabels.length) return false;

    allAlertLabels.forEach(function(label, idx) {
      var stock = label.getAttribute('data-stock');
      if (!stock) return;
      var fieldset = label.closest('fieldset');
      if (!fieldset) return;
      fieldset.style.position = 'relative';
      var text = document.createElement('span');
      text.className = 'cultefc-stock-text';
      text.textContent = stock;
      text.dataset.idx = idx;
      text.style.cssText = 'position:absolute;transform:translateX(-50%);font-size:11px;font-weight:700;color:#E02020;white-space:nowrap;pointer-events:none;z-index:5;line-height:1;';
      fieldset.appendChild(text);
    });
    return true;
  }

  function syncAlerts() {
    var existing = document.querySelectorAll('.cultefc-stock-text');
    var labels = document.querySelectorAll('.variant-option__button-label.has-stock-alert');
    if (existing.length !== labels.length) {
      createAlerts();
    }
    requestAnimationFrame(placeAlerts);
  }

  function observeVariantPicker() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var observer = new MutationObserver(function() {
      clearTimeout(window._cultefcTimer);
      window._cultefcTimer = setTimeout(syncAlerts, 50);
    });
    observer.observe(picker, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-current-checked', 'checked', 'data-option-available']
    });
  }

  function init() {
    createAlerts();
    requestAnimationFrame(placeAlerts);
    observeVariantPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', function() { requestAnimationFrame(placeAlerts); });

})();
